<template>
  <div class="m-edition-billing-users-monitoring">
    <div class="m-edition-billing-users-monitoring-form">
      <AtomInputPrimary
        v-model="email"
        :placeholder="$t('mEditionBillingUsersMonitoring.placeholders.emailInput')"
        inputClass="m-edition-billing-users-monitoring-input"
        wrapperClass="a-input-wrapper-row"
        required
      />
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.readVenta"
        @readUserMonitoring="readUserMonitoring"
      />
    </div>
    <div
      v-if="showLoadingState"
      key="loadingState"
    >
      <AtomLoadingSecondary/>
    </div>
    <div
      :class="`margin-bottom-xxlarge a-alert ${message.class}`"
      v-if="message.show"
    >
      <span class="a-alert-message">
        {{ message.text }}
      </span>
    </div>

    <div
      v-if="perfil"
      key="academyUserProfile"
      class="m-edition-billing-users-monitoring-info margin-bottom-xxlarge"
    >
      <div class="m-edition-billing-users-monitoring-info-body">
        <div class="display-flex-row-center profile-info-user">
          <AtomAvatarSecondary
            avatar-class="xlarge profile-info-user-avatar"
            :user-image="perfil.avatar"
          />
          <span class="display-flex-column font-weight-light justify-content-center profile-info-user-email">
            <span
              v-if="perfil.persona && perfil.persona.razon_social"
              class="font-size-large"
            >
              <b>{{ perfil.persona.razon_social }}</b>
            </span>
            <span class="font-weight-bold text-color-success">
              {{ perfil.email }}
            </span>
            <span class="font-size-small text-color-black-55">
              {{ $t('mEditionBillingUsersMonitoring.messages.activeSince') }}
              <span class="text-transform-capitalize">
                {{ $moment.parseZone(perfil.fecha_alta).format('D MMMM YYYY') }}
              </span>
            </span>
            <span class="font-size-small text-color-black-55">
              {{ $t('mEditionBillingUsersMonitoring.messages.lastLogin') }}
              <span v-if="tracking && tracking.ultimo_login && tracking.ultimo_login.ultimo_login">
                {{ $moment.parseZone(tracking.ultimo_login.ultimo_login).format('D MMMM YYYY HH:mm') }}
                <span v-if="tracking.ultimo_login.ultimo_login_ip">
                  &bull; IP {{ tracking.ultimo_login.ultimo_login_ip }}
                </span>
              </span>
              <span v-else>
                {{ `(${$t('mEditionBillingUsersMonitoring.messages.noTracking')})` }}
              </span>
            </span>
          </span>
        </div>

        <div class="profile-info-persona">
          <p class="display-flex-row">
            <span class="margin-right-small profile-info-persona-icon">
              <i class="fas fa-map-marker-alt"></i>
            </span>
            <span
              v-if="perfil.persona && perfil.persona.domicilio"
              class="profile-info-persona-text"
            >
              <span> {{ perfil.persona.domicilio.provincia.pais.nombre }} </span>
              <span>, {{ perfil.persona.domicilio.provincia.nombre }} </span>
              <span v-if="perfil.persona.domicilio.localidad">
                , {{ perfil.persona.domicilio.localidad }}
              </span>
              <span v-if="perfil.persona.domicilio.codigo_postal">
                , {{ perfil.persona.domicilio.codigo_postal }}
              </span>
              <span v-if="perfil.persona.domicilio.linea1">
                , {{ perfil.persona.domicilio.linea1 }} </span>
              <span v-if="perfil.persona.domicilio.linea2">
                {{ perfil.persona.domicilio.linea2 }} </span>
            </span>
            <span
              v-else
              class="profile-info-persona-text"
            >
              {{ `(${$t('mEditionBillingUsersMonitoring.messages.noLocation')})` }}
            </span>
          </p>

          <p class="display-flex-row">
            <span class="margin-right-small profile-info-persona-icon">
              <i class="fas fa-balance-scale"></i>
            </span>
            <span
              v-if="perfil.persona && perfil.persona.documento"
              class="profile-info-persona-text"
            >
              {{ $filters.getPersonValue(+perfil.persona.fisica, 'name') }}
              <span v-if="perfil.persona.documento && perfil.persona.documento.tipo.id_documento_tipo !== 1 &&  perfil.persona.documento.tipo.nombre !== 'ID' &&  perfil.persona.documento.numero">
                &bull;
                {{ perfil.persona.documento.tipo.nombre }}
                {{ perfil.persona.documento.numero }}
              </span>
            </span>
            <span
              v-else
              class="profile-info-persona-text"
            >
              {{ `(${$t('mEditionBillingUsersMonitoring.messages.noLegal')})` }}
            </span>
          </p>

          <p class="display-flex-row">
            <span class="margin-right-small profile-info-persona-icon">
              <i class="fas fa-mobile-alt"></i>
            </span>
            <span
              v-if="perfil.persona"
              class="profile-info-persona-text"
            >
              {{ $t('mEditionBillingUsersMonitoring.messages.phone') }}
              {{ perfil.persona.telefono || `(${$t('mEditionBillingUsersMonitoring.messages.noNumber')})` }}
              &bull;
              {{ $t('mEditionBillingUsersMonitoring.messages.mobile') }}
              {{ perfil.persona.movil || `(${$t('mEditionBillingUsersMonitoring.messages.noNumber')})` }}
            </span>
            <span
              v-else
              class="profile-info-persona-text"
            >
              {{ `(${$t('mEditionBillingUsersMonitoring.messages.noContact')})` }}
            </span>
          </p>
        </div>
      </div>
      <div
        class="m-edition-billing-users-monitoring-info-body">
        <!-- Sin academias no se pinta el encabezado: quedaba un titulo suelto sobre una lista vacia. -->
        <h4 v-if="perfil.academias_actores && perfil.academias_actores.length">
          {{ `${$t('mEditionBillingUsersMonitoring.titleAssets')}` }}
        </h4>
        <ul class="a-list-clean margin-bottom-zero margin-top-zero width-100-pr">
          <li
            class="margin-bottom-medium"
            v-for="(academia, indexP) in perfil.academias_actores"
            :key="indexP"
          >
            <p>
              <span class="info-icon info-icon-billing">
                <i class="fas fa-school"></i>
              </span>
              <span>
                {{ academia.nombre }}
              </span>
            </p>
            <p class="font-style-italic font-weight-light padding-left-small">
              <span class="margin-right-xsmall">-</span>
              <span>
                {{ $t('mEditionBillingUsersMonitoring.labels.academyOwner') }}
              </span>
              <span
                v-if="academia.es_propietario"
                class="font-weight-bold font-style-italic info-text-highlighted-success"
              >
                {{ $t('mEditionBillingUsersMonitoring.labels.yes') }}
              </span>
              <span
                v-else
                class="font-weight-bold font-style-italic info-text-highlighted-danger"
              >
                {{ $t('mEditionBillingUsersMonitoring.labels.no') }}
              </span>
            </p>
            <p class="font-style-italic font-weight-light padding-left-small">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.academyUrl') }}:
              </span>
              <span class="font-style-italic">
                {{ academia.url }}
              </span>
            </p>
            <p class="font-style-italic font-weight-light padding-left-small">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.storeUrl') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${tienda}/${academia.url}`"
                target="_blank"
              >
                {{ $t('mEditionBillingUsersMonitoring.labels.clickHere') }}
              </a>
            </p>
            <p class="font-style-italic font-weight-light padding-left-small">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.classroomUrl') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${aulaUrl}/login/${academia.id}`"
                target="_blank"
              >
                  {{ $t('mEditionBillingUsersMonitoring.labels.clickHere') }}
              </a>
            </p>
            <p class="font-style-italic font-weight-light padding-left-small">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.relatedSales') }}
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/academia-ventas?academia_url=${academia.url}&buscar=${perfil.email}`"
                target="_blank"
              >
                  {{ $t('mEditionBillingUsersMonitoring.labels.clickHere') }}
              </a>
            </p>
            <ul>
              <li
                v-for="(actor, indexL) in academia.actores"
                :key="indexL"
              >
                <p class="font-style-italic font-weight-light">
                  <span class="margin-right-xsmall">-</span>
                  <span>
                    {{ actoresTipo.find(actorTipo => actorTipo.id === actor.tipo).name }}
                  </span>
                  <span
                    v-if="actor.habilitado"
                    class="font-weight-bold info-text-highlighted-success"
                  >
                    {{ $t('mEditionBillingUsersMonitoring.labels.active') }}
                  </span>
                  <span
                    v-else
                    class="font-weight-bold info-text-highlighted-danger"
                  >
                    {{ $t('mEditionBillingUsersMonitoring.labels.inactive') }}
                  </span>
                  <span>
                    {{ $moment.parseZone(actor.fecha_alta).format('D MMMM, YYYY') }}
                  </span>
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!--
      El v-if va en el envoltorio y no en el mismo nodo del v-for: en Vue 2 el v-for tiene
      prioridad, asi que `perfil.licencia_full` se evaluaba ANTES de comprobar `perfil` y la
      pantalla reventaba mientras el perfil todavia no habia llegado.
    -->
    <template v-if="perfil">
    <div
      class="m-edition-billing-users-monitoring-info margin-bottom-xxlarge"
      v-for="(licencia_full, indexP) in perfil.licencia_full"
      :key="indexP"
    >
      <div
        class="m-edition-billing-users-monitoring-info-body"
      >
        <h4>
          {{ $t('mEditionBillingUsersMonitoring.labels.licenses') }}: {{ licencia_full.venta.concepto }}
        </h4>
        <ul class="a-list-clean margin-bottom-zero margin-top-zero width-100-pr">
          <li>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span>
                {{ $t('mEditionBillingUsersMonitoring.labels.license') }}
              </span>
              <span
                v-if="licencia_full.licencia.activa"
                class="font-weight-bold font-style-italic info-text-highlighted-success"
              >
                Activa
              </span>
              <span
                v-else
                class="font-weight-bold font-style-italic info-text-highlighted-danger"
              >
                Inactiva
              </span>
            </p>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.licenseCreatedDate') }}:
              </span>
              <span class="text-transform-capitalize font-style-italic">
                  {{ $moment.parseZone(licencia_full.licencia.fecha_alta).format('D MMMM, YYYY') }}
                </span>
            </p>
            <p v-if="licencia_full.academia && licencia_full.academia.nombre">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.academy') }}:
              </span>
              <span class="font-style-italic">
                {{ licencia_full.academia.nombre }}
              </span>
            </p>
            <p v-else>
              <span class="margin-right-xsmall">-</span>
              <span class="">
                {{ $t('mEditionBillingUsersMonitoring.labels.noAcademyAssigned') }}
              </span>
            </p>
            <p v-if="licencia_full.hasOwnProperty('academia_estado')">
              <span class="margin-right-xsmall">-</span>
              <span>
                {{ $t('mEditionBillingUsersMonitoring.labels.academy') }}
              </span>
              <span
                v-if="licencia_full.academia_estado"
                class="font-weight-bold font-style-italic info-text-highlighted-success"
              >
                {{ $t('mEditionBillingUsersMonitoring.labels.active') }}
              </span>
              <span
                v-else
                class="font-weight-bold font-style-italic info-text-highlighted-danger"
              >
                {{ $t('mEditionBillingUsersMonitoring.labels.inactive') }}
              </span>
            </p>
            <p v-if="licencia_full.academia_fecha_alta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.academyCreatedDate') }}:
              </span>
              <span class="text-transform-capitalize font-style-italic">
                  {{ $moment.parseZone(licencia_full.academia_fecha_alta).format('D MMMM, YYYY') }}
                </span>
            </p>
            <p v-if="licencia_full.academia && licencia_full.academia.url">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.academyUrl') }}:
              </span>
              <span class="font-style-italic">
                {{ licencia_full.academia.url }}
              </span>
            </p>
            <p v-if="licencia_full.academia && licencia_full.academia.id">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.academyDetails') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/academias/${licencia_full.academia.id}/datos`"
                target="_blank"
              >
                {{ salesUrl + '/gestion/academias/' + licencia_full.academia.id + '/datos' }}
              </a>
            </p>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.sale') }}
                <span :class="[$filters.getSaleStateValue(licencia_full.venta.estado.estado, 'class'), 'font-style-italic font-weight-bold']">
                  {{ $filters.getSaleStateValue(licencia_full.venta.estado.estado, 'name') }}
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.since') }}
                <span class="text-transform-capitalize font-style-italic">
                  {{ $moment.parseZone(licencia_full.venta.estado.fecha).format('D MMMM, YYYY') }}
                </span>
              </span>
            </p>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.saleDetails') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/academia-ventas/${licencia_full.licencia.venta}/registro`"
                target="_blank"
              >
                {{ salesUrl + '/gestion/academia-ventas/' + licencia_full.licencia.venta + '/registro' }}
              </a>
            </p>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.saleIdForMigrations') }}:
              </span>
              <span class="font-style-italic">
                {{ licencia_full.venta.id }}
              </span>
            </p>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.productDetails') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/academia-productos/${licencia_full.venta.producto}/detalle`"
                target="_blank"
              >
                {{ salesUrl + '/gestion/academia-productos/' + licencia_full.venta.producto + '/detalle' }}
              </a>
            </p>
            <p v-if="licencia_full.academia && licencia_full.academia.url">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.storeUrl') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${tienda}/${licencia_full.academia.url}`"
                target="_blank"
              >
                {{ tienda + '/' + licencia_full.academia.url }}
              </a>
            </p>
            <p v-if="licencia_full.academia && licencia_full.academia.id">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.classroomUrl') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${aulaUrl}/login/${licencia_full.academia.id}`"
                target="_blank"
              >
                {{ aulaUrl + '/login/' + licencia_full.academia.id }}
              </a>
            </p>
            <div v-if="licencia_full.recursos">
              <h4>
                {{ $t('mEditionBillingUsersMonitoring.labels.resourcesUsed') }}
              </h4>
              <p v-if="licencia_full.recursos.hasOwnProperty('alumnos') && licencia_full.recursos.hasOwnProperty('maximo_alumnos')">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-users"></i>
                  </span>
                    {{ $t('mEditionBillingUsersMonitoring.labels.students') }}
                  <span class="font-size-xsmall text-color-black-45"> ({{ licencia_full.recursos.alumnos }} de {{ licencia_full.recursos.maximo_alumnos }}) </span>
                </span>
                <span class="info-text-right">
                </span>
              </p>
              <p v-if="licencia_full.recursos.hasOwnProperty('proyectos')">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-folder"></i>
                  </span>
                    {{ $t('mEditionBillingUsersMonitoring.labels.projects') }}
                    <span class="font-size-xsmall text-color-black-45"> ({{ licencia_full.recursos.proyectos }} de {{ $t('mEditionBillingUsersMonitoring.labels.unlimited') }}) </span>
                </span>
                <span class="info-text-right">
                </span>
              </p>
              <p v-if="licencia_full.recursos.hasOwnProperty('mapas')">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-map-marker-alt"></i>
                  </span>
                    {{ $t('mEditionBillingUsersMonitoring.labels.learningMaps') }}
                    <span class="font-size-xsmall text-color-black-45"> ({{ licencia_full.recursos.mapas }} de {{ $t('mEditionBillingUsersMonitoring.labels.unlimited') }}) </span>
                </span>
                <span class="info-text-right">
                </span>
              </p>
              <p v-if="licencia_full.recursos.hasOwnProperty('productos')">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-box-open"></i>
                  </span>
                    {{ $t('mEditionBillingUsersMonitoring.labels.products') }}
                    <span class="font-size-xsmall text-color-black-45"> ({{ licencia_full.recursos.productos }} de {{ $t('mEditionBillingUsersMonitoring.labels.unlimited') }}) </span>
                </span>
                <span class="info-text-right">
                </span>
              </p>
              <p v-if="false">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing">
                    <i class="fas fa-envelope"></i>
                  </span>
                    Listas de e-mail
                </span>
                <span class="info-text-right">
                  {{ licencia_full.recursos.maximo_emails }}
                </span>
              </p>
              <p v-if="licencia_full.recursos.hasOwnProperty('puntos_venta')">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-file-alt"></i>
                  </span>
                    {{ $t('mEditionBillingUsersMonitoring.labels.salesPoints') }}
                    <span class="font-size-xsmall text-color-black-45"> ({{ licencia_full.recursos.puntos_venta }} de {{ $t('mEditionBillingUsersMonitoring.labels.unlimited') }}) </span>
                </span>
                <span class="info-text-right">
                </span>
              </p>
              <p v-if="false">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-graduation-cap"></i>
                  </span>
                    Universidad Profesional
                </span>
                <span class="info-text-right">
                  <span v-if="licencia_full.licencia.tipo_universidad" class="font-weight-bold info-text-highlighted-success"> Si </span>
                  <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
                </span>
              </p>
              <p v-if="false">
                <span class="info-text-left">
                  <span class="info-icon-left info-icon-billing-sin-border">
                    <i class="fas fa-puzzle-piece"></i>
                  </span>
                    Integraciones
                </span>
                <span class="info-text-right">
                  <span class="info-icon-right info-icon-billing-sin-border">
                    <i :class="licencia_full.licencia.integraciones ? 'far fa-check font-weight-bold' : 'far fa-cross font-weight-bold'"></i>
                  </span>
                </span>
              </p>
            </div>
            <div v-if="licencia_full.academia && licencia_full.academia.url">
              <h4>
                {{ $t('mEditionBillingUsersMonitoring.labels.quickAccess') }}
              </h4>
              <p v-if="licencia_full.academia && licencia_full.academia.url">
                <span class="margin-right-xsmall">-</span>
                <span class="margin-right-xsmall">
                  {{ $t('mEditionBillingUsersMonitoring.labels.productsByAcademy') }}:
                </span>
                <a
                  class="font-style-italic"
                  :href="`${salesUrl}/gestion/academia-productos?academia_url=${licencia_full.academia.url}`"
                  target="_blank"
                >
                  {{ salesUrl + '/gestion/academia-productos?academia_url=' + licencia_full.academia.url }}
                </a>
              </p>
              <p v-if="licencia_full.academia && licencia_full.academia.url">
                <span class="margin-right-xsmall">-</span>
                <span class="margin-right-xsmall">
                  {{ $t('mEditionBillingUsersMonitoring.labels.projectsByAcademy') }}:
                </span>
                <a
                  class="font-style-italic"
                  :href="`${salesUrl}/gestion/academia-proyectos?academia_url=${licencia_full.academia.url}`"
                  target="_blank"
                >
                  {{ salesUrl + '/gestion/academia-proyectos?academia_url=' + licencia_full.academia.url }}
                </a>
              </p>
              <p v-if="licencia_full.academia && licencia_full.academia.url">
                <span class="margin-right-xsmall">-</span>
                <span class="margin-right-xsmall">
                  {{ $t('mEditionBillingUsersMonitoring.labels.chargesByAcademy') }}:
                </span>
                <a
                  class="font-style-italic"
                  :href="`${salesUrl}/gestion/academia-cobros?academia_url=${licencia_full.academia.url}`"
                  target="_blank"
                >
                  {{ salesUrl + '/gestion/academia-cobros?academia_url=' + licencia_full.academia.url }}
                </a>
              </p>
              <p v-if="licencia_full.academia && licencia_full.academia.url">
                <span class="margin-right-xsmall">-</span>
                <span class="margin-right-xsmall">
                  {{ $t('mEditionBillingUsersMonitoring.labels.salesByAcademy') }}:
                </span>
                <a
                  class="font-style-italic"
                  :href="`${salesUrl}/gestion/academia-ventas?academia_url=${licencia_full.academia.url}`"
                  target="_blank"
                >
                  {{ salesUrl + '/gestion/academia-ventas?academia_url=' + licencia_full.academia.url }}
                </a>
              </p>
              <p v-if="licencia_full.academia && licencia_full.academia.url">
                <span class="margin-right-xsmall">-</span>
                <span class="margin-right-xsmall">
                  {{ $t('mEditionBillingUsersMonitoring.labels.clientsByAcademy') }}:
                </span>
                <a
                  class="font-style-italic"
                  :href="`${salesUrl}/gestion/academia-clientes?academia_url=${licencia_full.academia.url}`"
                  target="_blank"
                >
                  {{ salesUrl + '/gestion/academia-clientes?academia_url=' + licencia_full.academia.url }}
                </a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    </template>
    <!--
      Los Droops (satelites) del usuario.
      Bloque propio y no dentro de licencia_full porque son licencias distintas: no tienen academia
      ni comparten limites, y quien compro SOLO un Droop no tiene ninguna licencia de academia.
      Se listan todas, incluidas las dadas de baja y las reemplazadas por un cambio de plan: en el
      monitoreo interesa la historia, que es lo que se viene a mirar cuando un cliente reclama.
    -->
    <template v-if="perfil && perfil.licencia_satelite_full">
    <div
      class="m-edition-billing-users-monitoring-info margin-bottom-xxlarge"
      v-for="(droop, indexD) in perfil.licencia_satelite_full"
      :key="'droop-' + indexD"
    >
      <div class="m-edition-billing-users-monitoring-info-body">
        <h4>
          {{ $t('mEditionBillingUsersMonitoring.labels.droops') }}: {{ droop.licencia.titulo }}
        </h4>
        <ul class="a-list-clean margin-bottom-zero margin-top-zero width-100-pr">
          <li>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.license') }}
              </span>
              <span
                v-if="droop.licencia.activo && !droop.licencia.eliminado"
                class="font-weight-bold font-style-italic info-text-highlighted-success"
              >
                {{ $t('mEditionBillingUsersMonitoring.labels.active') }}
              </span>
              <span
                v-else
                class="font-weight-bold font-style-italic info-text-highlighted-danger"
              >
                {{ droop.licencia.eliminado
                  ? $t('mEditionBillingUsersMonitoring.labels.deleted')
                  : $t('mEditionBillingUsersMonitoring.labels.inactive') }}
              </span>
            </p>
            <p v-if="droop.licencia.fecha_alta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.licenseCreatedDate') }}:
              </span>
              <span class="text-transform-capitalize font-style-italic">
                {{ $moment.parseZone(droop.licencia.fecha_alta).format('D MMMM, YYYY') }}
              </span>
            </p>
            <p v-if="droop.licencia.cuenta_satelite">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.droopAccount') }}:
              </span>
              <span class="font-style-italic">{{ droop.licencia.cuenta_satelite }}</span>
            </p>
            <!-- La venta puede faltar: una licencia cargada a mano no nacio de una compra. -->
            <p v-if="droop.venta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.sale') }}:
              </span>
              <span class="font-style-italic margin-right-xsmall">{{ droop.venta.concepto }}</span>
              <span
                v-if="droop.venta.estado"
                :class="[$filters.getSaleStateValue(droop.venta.estado.estado, 'class'), 'font-style-italic font-weight-bold']"
              >
                {{ $filters.getSaleStateValue(droop.venta.estado.estado, 'name') }}
              </span>
            </p>
            <p v-else>
              <span class="margin-right-xsmall">-</span>
              <span>{{ $t('mEditionBillingUsersMonitoring.labels.noSaleAssigned') }}</span>
            </p>
            <p v-if="droop.licencia.venta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.saleDetails') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/academia-ventas/${droop.licencia.venta}/registro`"
                target="_blank"
              >
                {{ salesUrl + '/gestion/academia-ventas/' + droop.licencia.venta + '/registro' }}
              </a>
            </p>
            <h4>
              {{ $t('mEditionBillingUsersMonitoring.labels.resourcesUsed') }}
            </h4>
            <!--
              Cada Droop mide lo suyo: el backend manda `tipo` en cada entrada. Juedroop: juegos es
              el unico consumo acumulable de la cuenta, asi que es el unico que se muestra como
              "X de Y"; el resto son topes (preguntas POR JUEGO, jugadores POR SALA). Evaluaciones:
              evaluaciones creadas contra el maximo, y el tope de preguntas POR EVALUACION.
              Ruleta: lo mismo, ruletas creadas contra el maximo y el tope de segmentos POR RULETA.
              Un maximo en 0 significa "sin tope" en todo el producto.
            -->
            <template v-if="droop.tipo === 'evaluacion'">
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-clipboard-check"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopEvaluations') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.evaluaciones }} de {{ droop.licencia.maximo_evaluaciones > 0
                    ? droop.licencia.maximo_evaluaciones
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-question"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopQuestionsPerEvaluation') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.licencia.maximo_preguntas_por_evaluacion > 0
                    ? droop.licencia.maximo_preguntas_por_evaluacion
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            </template>
            <template v-else-if="droop.tipo === 'ruleta'">
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-dharmachakra"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopRoulettes') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.ruletas }} de {{ droop.licencia.maximo_ruletas > 0
                    ? droop.licencia.maximo_ruletas
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-chart-pie"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopSegmentsPerRoulette') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.licencia.maximo_segmentos_por_ruleta > 0
                    ? droop.licencia.maximo_segmentos_por_ruleta
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p
              v-for="modo in [
                { campo: 'modo_premios', etiqueta: 'droopPrizesMode', icono: 'fas fa-gift' },
                { campo: 'modo_preguntas', etiqueta: 'droopQuestionsMode', icono: 'fas fa-question' },
                { campo: 'enlace_publico', etiqueta: 'droopPublicLink', icono: 'fas fa-link' },
                { campo: 'exportacion_csv', etiqueta: 'droopCsvExport', icono: 'fas fa-file-csv' }
              ]"
              :key="modo.campo"
            >
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i :class="modo.icono"></i>
                </span>
                {{ $t(`mEditionBillingUsersMonitoring.labels.${modo.etiqueta}`) }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.licencia[modo.campo]
                    ? $t('mEditionBillingUsersMonitoring.labels.yes')
                    : $t('mEditionBillingUsersMonitoring.labels.no') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            </template>
            <template v-else>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-gamepad"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopGames') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.juegos }} de {{ droop.licencia.maximo_juegos > 0
                    ? droop.licencia.maximo_juegos
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-question"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopQuestionsPerGame') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.licencia.maximo_preguntas_por_juego > 0
                    ? droop.licencia.maximo_preguntas_por_juego
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-users"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopPlayersPerRoom') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.licencia.maximo_jugadores_por_sala > 0
                    ? droop.licencia.maximo_jugadores_por_sala
                    : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-user"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopIndividualMode') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ droop.licencia.modo_individual
                    ? $t('mEditionBillingUsersMonitoring.labels.yes')
                    : $t('mEditionBillingUsersMonitoring.labels.no') }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-broadcast-tower"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.labels.droopLiveMode') }}
                <span class="font-size-xsmall text-color-black-45">
                  <template v-if="droop.licencia.modo_en_vivo">
                    ({{ $t('mEditionBillingUsersMonitoring.labels.yes') }} ·
                    {{ $t('mEditionBillingUsersMonitoring.labels.droopPlayersLive') }}:
                    {{ droop.licencia.maximo_jugadores_por_sala_en_vivo > 0
                      ? droop.licencia.maximo_jugadores_por_sala_en_vivo
                      : $t('mEditionBillingUsersMonitoring.labels.unlimited') }})
                  </template>
                  <template v-else>
                    ({{ $t('mEditionBillingUsersMonitoring.labels.no') }})
                  </template>
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            </template>
          </li>
        </ul>
      </div>
    </div>
    </template>
    <!--
      La Inteligencia Artificial del usuario, en `licencias_ia` y no en licencia_satelite_full: no
      cuenta recursos sino creditos, y en aquella lista caeria en la rama de Juedroop.
      Una licencia por compra (el plan mensual o cada paquete de creditos), todas, tambien las
      suspendidas, reemplazadas por un cambio de plan o eliminadas: soporte mira aca el consumo antes
      de reembolsar un paquete, que solo se devuelve si no se uso.
      Los creditos son siempre el numero real: un 0 es un 0, nunca "ilimitado" como en los Droops.
    -->
    <template v-if="perfil && perfil.licencias_ia">
    <div
      class="m-edition-billing-users-monitoring-info margin-bottom-xxlarge"
      v-for="(ia, indexIa) in perfil.licencias_ia"
      :key="'ia-' + indexIa"
    >
      <div class="m-edition-billing-users-monitoring-info-body">
        <h4>
          {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.title') }}: {{ ia.licencia.titulo }}
        </h4>
        <ul class="a-list-clean margin-bottom-zero margin-top-zero width-100-pr">
          <li>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.modality') }}:
              </span>
              <span class="font-style-italic">
                {{ $t(`mEditionBillingUsersMonitoring.artificialIntelligence.modalities.${ia.modalidad}`) }}
              </span>
            </p>
            <p>
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.license') }}
              </span>
              <span :class="['font-weight-bold font-style-italic', claseEstadoIa(ia)]">
                {{ $t(`mEditionBillingUsersMonitoring.artificialIntelligence.states.${estadoIa(ia)}`) }}
              </span>
            </p>
            <p v-if="ia.licencia.fecha_alta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.licenseCreatedDate') }}:
              </span>
              <span class="text-transform-capitalize font-style-italic">
                {{ $moment.parseZone(ia.licencia.fecha_alta).format('D MMMM, YYYY') }}
              </span>
            </p>
            <p v-if="ia.licencia.cuenta_satelite">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.account') }}:
              </span>
              <span class="font-style-italic">{{ ia.licencia.cuenta_satelite }}</span>
            </p>
            <!-- La venta puede faltar: una licencia cargada a mano no nacio de una compra. -->
            <p v-if="ia.venta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.sale') }}:
              </span>
              <span class="font-style-italic margin-right-xsmall">{{ ia.venta.concepto }}</span>
              <span
                v-if="ia.venta.estado"
                :class="[$filters.getSaleStateValue(ia.venta.estado.estado, 'class'), 'font-style-italic font-weight-bold']"
              >
                {{ $filters.getSaleStateValue(ia.venta.estado.estado, 'name') }}
              </span>
            </p>
            <p v-else>
              <span class="margin-right-xsmall">-</span>
              <span>{{ $t('mEditionBillingUsersMonitoring.labels.noSaleAssigned') }}</span>
            </p>
            <p v-if="ia.licencia.venta">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.labels.saleDetails') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/academia-ventas/${ia.licencia.venta}/registro`"
                target="_blank"
              >
                {{ salesUrl + '/gestion/academia-ventas/' + ia.licencia.venta + '/registro' }}
              </a>
            </p>
            <!-- La ficha del monitoreo interno: cuanto costo el proveedor y que genero de verdad -->
            <p v-if="ia.licencia.id">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.usageRecord') }}:
              </span>
              <a
                class="font-style-italic"
                :href="`${salesUrl}/gestion/inteligencia-artificial-consumo/${ia.licencia.id}/ficha`"
                target="_blank"
              >
                {{ salesUrl + '/gestion/inteligencia-artificial-consumo/' + ia.licencia.id + '/ficha' }}
              </a>
            </p>
            <!-- El bool del plan mensual: con No, al agotarse el mes no usa los paquetes aunque tenga -->
            <p v-if="ia.modalidad === 'mensual' && typeof ia.licencia.usar_creditos === 'boolean'">
              <span class="margin-right-xsmall">-</span>
              <span class="margin-right-xsmall">
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.useCredits') }}:
              </span>
              <span class="font-style-italic">
                {{ ia.licencia.usar_creditos
                  ? $t('mEditionBillingUsersMonitoring.labels.yes')
                  : $t('mEditionBillingUsersMonitoring.labels.no') }}
              </span>
            </p>
            <h4>
              {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.credits') }}
            </h4>
            <!--
              Mensual: el disponible es creditos - consumo del mes (vuelve a 0 el dia 1).
              Paquete: creditos - consumo acumulado (no vuelve nunca). Lo calcula el core-api.
            -->
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-coins"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.creditsTotal') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ creditosIa(ia) }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-battery-half"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.available') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ $utils.formatCredits(ia.disponible) }}
                  {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.of') }}
                  {{ $utils.formatCredits(ia.licencia.creditos) }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p v-if="ia.licencia.periodo">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-calendar-alt"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.period') }}
                <span class="font-size-xsmall text-color-black-45 text-transform-capitalize">
                  ({{ mesIa(ia.licencia.periodo) }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-chart-pie"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.monthConsumption') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ $utils.formatCredits(ia.licencia.consumo_total) }}:
                  {{ consumoPorAppIa(ia.licencia) }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing-sin-border">
                  <i class="fas fa-history"></i>
                </span>
                {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.accumulatedConsumption') }}
                <span class="font-size-xsmall text-color-black-45">
                  ({{ $utils.formatCredits(ia.licencia.consumo_acumulado) }})
                </span>
              </span>
              <span class="info-text-right"></span>
            </p>
            <h4>
              {{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.history') }}
            </h4>
            <!-- Una fila por mes cerrado (el cron del dia 1), del mas nuevo al mas viejo. El mes en curso
                 es el "consumo del mes" de arriba. -->
            <div
              v-if="ia.historico && ia.historico.length"
              class="m-edition-billing-users-monitoring-ia-history"
            >
              <table>
                <tr>
                  <th>{{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.historyColumns.period') }}</th>
                  <th
                    v-for="app in appsIa"
                    :key="'th-' + app"
                  >
                    {{ $t(`mEditionBillingUsersMonitoring.artificialIntelligence.apps.${app}`) }}
                  </th>
                  <th>{{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.historyColumns.total') }}</th>
                  <th>{{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.historyColumns.accumulated') }}</th>
                  <th>{{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.historyColumns.credits') }}</th>
                  <th>{{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.historyColumns.current') }}</th>
                </tr>
                <tr
                  v-for="mes in historicoIa(ia)"
                  :key="'mes-' + mes.periodo"
                >
                  <td class="text-transform-capitalize">{{ mesIa(mes.periodo) }}</td>
                  <td
                    v-for="app in appsIa"
                    :key="'td-' + app"
                  >
                    {{ $utils.formatCredits(mes['consumo_' + app]) }}
                  </td>
                  <td class="font-weight-bold">{{ $utils.formatCredits(mes.consumo_total) }}</td>
                  <td>{{ $utils.formatCredits(mes.consumo_acumulado) }}</td>
                  <td>{{ $utils.formatCredits(mes.creditos) }}</td>
                  <td>
                    {{ mes.vigente
                      ? $t('mEditionBillingUsersMonitoring.labels.yes')
                      : $t('mEditionBillingUsersMonitoring.labels.no') }}
                  </td>
                </tr>
              </table>
            </div>
            <p v-else>
              <span class="margin-right-xsmall">-</span>
              <span>{{ $t('mEditionBillingUsersMonitoring.artificialIntelligence.historyEmpty') }}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import configApp from '@/config'

// Apps que consumen Inteligencia Artificial, en el orden en que se muestran. Cada una es una columna
// consumo_<app> de la licencia y del historico (las mismas claves que LicenciaSateliteIa::APPS del core-api)
const APPS_IA = ['juedroop', 'evaluaciones', 'academy', 'classroom']

export default {
  name: 'MoleculeEditionBillingUsersMonitoring',

  data () {
    return {
      actoresTipo: [...this.$filters.parameters['actors']],

      academiaUrl: '',

      appsIa: APPS_IA,

      aulaUrl: '',

      buttonSecondary: {
        readVenta: {
          class: 'a-button-secondary a-button-billing-secondary margin-top-small',
          component: '',
          icon: 'fas fa-search',
          method: 'readUserMonitoring',
          text: 'Buscar',
          type: 'button'
        }
      },

      email: '',

      message: {
        class: '',
        text: '',
        show: false
      },

      perfil: '',

      salesUrl: '',

      showLoadingState: false,

      tienda: '',

      tracking: null
    }
  },

  created () {
    this.academiaUrl = configApp.appAcademyDomain + '/gestion/mis-ventas'
    this.aulaUrl = configApp.appAulaDomain
    this.salesUrl = configApp.appDomain
    this.tienda = configApp.marketPlaceDomain

    // Se puede llegar con el email ya puesto desde otra pantalla (?email=...): se busca solo
    if (this.$route.query.email) {
      this.email = this.$route.query.email
      this.readUserMonitoring()
    }
  },

  methods: {
    closeAlert () {
      this.message.show = false
    },

    // "Agotada" no es un estado guardado: la licencia sigue activa y el core-api avisa que no le queda
    // disponible. Suspendida es activo = false (impago, reembolso o reemplazada por un cambio de plan)
    estadoIa (ia) {
      if (ia.licencia.eliminado) {
        return 'eliminada'
      }

      if (!ia.licencia.activo) {
        return 'suspendida'
      }

      return ia.agotada ? 'agotada' : 'activa'
    },

    claseEstadoIa (ia) {
      const clases = {
        activa: 'info-text-highlighted-success',
        agotada: 'info-text-highlighted-warning',
        eliminada: 'info-text-highlighted-danger',
        suspendida: 'info-text-highlighted-danger'
      }

      return clases[this.estadoIa(ia)]
    },

    // "5.000 por mes" o "10.000, pago único"
    creditosIa (ia) {
      return this.$t(`mEditionBillingUsersMonitoring.artificialIntelligence.creditsBy.${ia.modalidad}`, {
        creditos: this.$utils.formatCredits(ia.licencia.creditos)
      })
    },

    // "Juedroop 3.100 · Evaluaciones 1.870 · Academy 0 · Classroom 0"
    consumoPorAppIa (licencia) {
      return APPS_IA
        .map(app => `${this.$t(`mEditionBillingUsersMonitoring.artificialIntelligence.apps.${app}`)} ${this.$utils.formatCredits(licencia[`consumo_${app}`])}`)
        .join(' · ')
    },

    // Del mes mas nuevo al mas viejo, sin depender del orden en que lo mande el core-api
    historicoIa (ia) {
      return [...ia.historico].sort((a, b) => `${b.periodo}`.localeCompare(`${a.periodo}`))
    },

    // El periodo es el primer dia del mes ("2026-09-01"): se muestra el mes ("septiembre 2026")
    mesIa (periodo) {
      return this.$moment(periodo, 'YYYY-MM-DD').format('MMMM YYYY')
    },

    readUserMonitoring () {
      const filter = {
        email: this.email
      }
      this.perfil = ''
      this.tracking = null
      this.showLoadingState = true
      this.message.show = false
      this.$services.read('usuario', 'readMonitoreoUsuario', { }, [], filter)
        .then(response => {
          this.showLoadingState = false
          console.log(response.data)
          /*
           * Antes alcanzaba con no tener academias para no mostrar NADA: la pantalla
           * cortaba aca y ni siquiera pintaba los datos del usuario.
           *
           * El comprador de un Droop suelto no tiene academia POR DEFINICION, asi que
           * para el el monitoreo decia siempre "No hay datos disponibles" aunque
           * tuviera su licencia, su venta y sus juegos. Ahora alcanza con que haya algo
           * que mostrar en cualquiera de los cuatro frentes: el ultimo es la Inteligencia
           * Artificial, que llega en su propia clave y puede ser lo unico que compro.
           */
          const academias = response.data.academias_actores || []
          const licencias = response.data.licencia_full || []
          const droops = response.data.licencia_satelite_full || []
          const inteligenciaArtificial = response.data.licencias_ia || []

          if (!academias.length && !licencias.length && !droops.length && !inteligenciaArtificial.length) {
            this.setMessage(this.$t('mEditionBillingUsersMonitoring.messages.noData'), 'a-alert-white text-color-black-65 ')
            return
          }
          this.perfil = response.data
          this.readTrackingResumen()
        })
        .catch(error => {
          this.showLoadingState = false
          this.setMessage(this.$t('mEditionBillingUsersMonitoring.messages.wrongEmail'), 'a-alert-white text-color-danger ')
          console.log(error)
        })
    },

    readTrackingResumen () {
      if (!this.perfil || !this.perfil.id) {
        return
      }
      this.$services.read('tracking', 'readTrackingUsuarioResumen', {}, [this.perfil.id])
        .then(response => {
          this.tracking = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

    setMessage (message, type) {
      this.message.class = type
      this.message.text = message
      this.message.show = true
    }
  }
}
</script>
